<template>
    <div class="c-match-handicap morebetdual" :id="'cmatch'+event.eveid">
      <div class="vrow no-wrap">
        <!-- 1x2btts  -->
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width:(widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">{{this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'] }}</div>
              </div>
              <bttstgft :event="event" :score="'ha'" :dual="'a'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="bttsoddyesha"/>
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5) + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">{{this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'] }}</div>
              </div>
              <bttstgft :event="event" :score="'aa'" :dual="'a'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="bttsoddyesab" />
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5) + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">{{this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'] }}</div>
              </div>
              <bttstgft :event="event" :score="'da'" :dual="'a'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="bttsoddyesaa" />
            </div>
          </div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">{{this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'] }}</div>
              </div>
              <bttstgft :event="event" :score="'hb'" :dual="'a'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="bttsoddshb" />
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">{{this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'] }}</div>
              </div>
              <bttstgft :event="event" :score="'ab'"  :dual="'a'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="bttsoddab" />
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">{{this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'] }}</div>
              </div>
              <bttstgft :event="event" :score="'db'" :dual="'a'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="bttsodddb" />
            </div>
          </div>
        </div>

        <!-- DBCH & BTTS -->
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width:(widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">
                  {{this.$store.getters.sportAllBetLang['ALL_BET.LBL_HD']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'] }}
                </div>
                <!-- <div class="handicap-value-text color-highlight"></div> -->
              </div>
              <bttstgft :event="event" :score="'ha'" :dual="oudual" :plyType="ftPlyType" :betType="betTypedbchbtts" ref="ouoddyesha"/>
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5) + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">
                  {{this.$store.getters.sportAllBetLang['ALL_BET.LBL_AD']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'] }}
                </div>
                <!-- <div class="handicap-value-text color-highlight"></div> -->
              </div>
              <bttstgft :event="event" :score="'aa'" :dual="oudual" :plyType="ftPlyType" :betType="betTypedbchbtts" ref="ouoddyesaa" />
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5) + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">
                  {{this.$store.getters.sportAllBetLang['ALL_BET.LBL_HA']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'] }}
                </div>
                <!-- <div class="handicap-value-text color-highlight"></div> -->
              </div>
              <bttstgft :event="event" :score="'da'" :dual="oudual" :plyType="ftPlyType" :betType="betTypedbchbtts" ref="ouoddyesda" />
            </div>
          </div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">
                  {{this.$store.getters.sportAllBetLang['ALL_BET.LBL_HD']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'] }}
                </div>
                <!-- <div class="handicap-value-text color-highlight"></div> -->
              </div>
              <!-- class="odds-right"  -->
              <bttstgft :event="event" :score="'hb'" :dual="oudual" :plyType="ftPlyType" :betType="betTypedbchbtts" ref="ouoddhb" />
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">
                  {{this.$store.getters.sportAllBetLang['ALL_BET.LBL_AD']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'] }}
                </div>
                <!-- <div class="handicap-value-text color-highlight"></div> -->
              </div>
              <!-- class="odds-right"  -->
              <bttstgft :event="event" :score="'ab'" :dual="oudual" :plyType="ftPlyType" :betType="betTypedbchbtts" ref="ouoddab" />
            </div>
          </div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: (widthColumn[1]*1.5)  + 'px !important' }" :title="this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']">
            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts">
              <div class="handicap-value">
                <span class="handicap-more" style="display: none;">&nbsp;</span>
                <div class="handicap-value-text ellipsis">
                  {{this.$store.getters.sportAllBetLang['ALL_BET.LBL_HA']}}  {{ this.$store.getters.sportAllBetLang['ALL_BET.AND'] }} {{ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'] }}
                </div>
                <!-- <div class="handicap-value-text color-highlight"></div> -->
              </div>
              <!-- class="odds-right"  -->
              <bttstgft :event="event" :score="'db'" :dual="oudual" :plyType="ftPlyType" :betType="betTypedbchbtts" ref="ouodddb" />
            </div>
          </div>
        </div>
       
        <template v-if="isUnfold">
          <template v-for="(n, key) in 5" v-if="widthColumn[3]==2">
            <div class="handicap-col">
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
            </div>
          </template>
          <template v-for="(n, key) in 6" v-if="widthColumn[3]==1">
            <div class="handicap-col">
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
            </div>
          </template>
          <template v-for="(n, key) in 7" v-if="widthColumn[3]==0">
            <div class="handicap-col">
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
              <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
            </div>
          </template>
        </template>
      </div>

    </div> 
  </template>
  
  <script>
  import {
    mapGetters,
  } from 'vuex'
  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'
  import OverUnderComponents from '../../../components/over-under'
  import allBetMixin from '../../../mixins/allBet'

  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent: null,
      event: null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
      widthColumn:null,
      isUnfold:false,
      eventbtts:null,
    },
    computed: {
      ...mapGetters([
        'mainMarketBet',
        'selectedShow',
        'moreBetLoading',
        'sportAllBetLang',
        'sportTableLang',
      ]),
      // filterEvent() {
      //   var eventbtts = _.cloneDeep(this.$store.getters.eventAllBet)
      //   console.log("mainmarket = "+JSON.stringify(eventbtts));
      //   return eventbtts
      // },
      // newAllBetEvent() {
      //   // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      //   console.log("allbetbtts = "+JSON.stringify(this.allBetEvent));
      //   return this.allBetEvent
      // },
    },
    data() {
      return {
        btypes: [allBetMixin.data().onex2bttsBetType, allBetMixin.data().ronex2bttsBetType],
        show: true,
        mainMarketList: null,
        bettype: (this.event.rbinfo ? allBetMixin.data().ronex2bttsBetType : allBetMixin.data().onex2bttsBetType),
        betTypeou: (this.event.rbinfo ? allBetMixin.data().ronex2ouBetType : allBetMixin.data().onex2ouBetType),
        betTypedbchbtts: (this.event.rbinfo ? allBetMixin.data().rdbchbttsBetType : allBetMixin.data().dbchbttsBetType),
        selectedMarket: null,
        lang: window.lang,
        oudual:'a',
        ousub:0,
        susub2:[],
      }
    },
    methods: {
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      addToMyMarket(plytyp, onex2bttsBetType) {
        if (this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, onex2bttsBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp, onex2bttsBetType) {
        if (this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, onex2bttsBetType, this.isSpecial)
      },
      getOuDual(event){
        let vue = this
        let betTypeou = [63,64]
        var getou = false;
        var getDual = '';

        _.forEach(this.event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(parseInt(k), betTypeou) > -1) {
              _.forEach(val, function (odd, d) {
                  if (Object.keys(val).includes('a')) {
                  getou = true
                  getDual = val['a']['dual']
                }
              })
            }
          })
        })

        if(getou){
          this.ousub = 0;
          this.oudual = getDual
        }
      },
    },
    mouted(){
    },
    beforeMount() {
      this.mainMarketList = _.cloneDeep(this.$store.getters.eventAllBet)
      this.getOuDual(event);
    },
  }
  </script>
  <style lang="scss">
  .bluebg{
    background-color: var(--qq--yb-bg-color23);
  }

  .color-highlight{
    color: var(--qq--yb-text-color20);
    font-weight: 500;
    white-space: nowrap;
    margin-left: 1px;
    margin-right: 3px;
  }

  .odds-right{
    margin-right: 3px  !important;
  }

  .morebetdual .handicap-value {
    position: absolute;
    left: 0;
    width: 63%;
    margin-left: 6px;
    justify-content: center;
  }
  </style>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/moreBet-1x2btts.vue